'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _is2 = require('ramda/src/is');

var _is3 = _interopRequireDefault(_is2);

var _find2 = require('ramda/src/find');

var _find3 = _interopRequireDefault(_find2);

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _templateObject = _taggedTemplateLiteral(['\n    display: block;\n    margin-top: -10px;\n    padding-left: 75px;\n\n    h4 {\n        font-size: 1.15rem;\n        font-weight: 500;\n    }\n    h4 + h4 {\n        font-size: .9rem;\n        font-weight: normal;\n    }\n\n    .subTitles {\n        h4 {\n            display: inline-block;\n        }\n    }\n'], ['\n    display: block;\n    margin-top: -10px;\n    padding-left: 75px;\n\n    h4 {\n        font-size: 1.15rem;\n        font-weight: 500;\n    }\n    h4 + h4 {\n        font-size: .9rem;\n        font-weight: normal;\n    }\n\n    .subTitles {\n        h4 {\n            display: inline-block;\n        }\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactFinalForm = require('react-final-form');

var _experiumPlayerHelpers = require('experium-player-helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var separatorTypes = {
    'date': true,
    'month_year': true,
    'year': true
};

var Titles = _styledComponents2.default.div(_templateObject);

var BlockTitles = function BlockTitles(_ref) {
    var item = _ref.item,
        name = _ref.name,
        index = _ref.index;
    return _react2.default.createElement(
        Titles,
        null,
        item.items.map(function (option, itemIndex) {
            return option.id ? _react2.default.createElement(_reactFinalForm.Field, {
                key: name + '[' + index + '].' + option.id,
                name: name + '[' + index + '].' + option.id,
                render: function render(_ref2) {
                    var input = _ref2.input;
                    return _react2.default.createElement(
                        'div',
                        null,
                        (0, _path3.default)(['select', 'selection'], option) === 'dropdown' ? _react2.default.createElement(
                            _experiumPlayerHelpers.DictionariesContext.Consumer,
                            null,
                            function (dictionaries) {
                                var dictionary = (0, _find3.default)(function (dict) {
                                    return dict.id === option.select.scaleid;
                                }, dictionaries);
                                var value = (0, _path3.default)(['value'], input);
                                var dictValue = (0, _find3.default)(function (dictOption) {
                                    return dictOption.id === (0, _path3.default)(['value'], value);
                                }, (0, _path3.default)(['eval'], dictionary) || []);

                                return _react2.default.createElement(
                                    'h4',
                                    null,
                                    (dictValue ? (0, _experiumPlayerHelpers.getText)(dictValue) : (0, _path3.default)(['value'], value)) || ''
                                );
                            }
                        ) : (0, _is3.default)(String, (0, _path3.default)(['value', 'value'], input)) && (0, _path3.default)(['input', 'type'], option) === 'text' ? _react2.default.createElement(
                            'h4',
                            null,
                            (0, _path3.default)(['value', 'value'], input)
                        ) : null,
                        (0, _path3.default)(['input', 'type'], option) === 'number' ? _react2.default.createElement(
                            'span',
                            null,
                            (0, _path3.default)(['value', 'value'], input)
                        ) : null,
                        (0, _path3.default)(['input', 'type'], option) === 'phone' ? _react2.default.createElement(
                            'span',
                            null,
                            (0, _path3.default)(['value', 'value'], input)
                        ) : null,
                        (0, _path3.default)(['input', 'type'], option) === 'email' ? _react2.default.createElement(
                            'span',
                            null,
                            (0, _path3.default)(['value', 'value'], input)
                        ) : null,
                        (0, _path3.default)(['input', 'type'], option) === 'date' ? _react2.default.createElement(
                            'span',
                            null,
                            (0, _experiumPlayerHelpers.getEncodedDateData)((0, _path3.default)(['value', 'value'], input)) || ''
                        ) : null,
                        (0, _path3.default)(['input', 'type'], option) === 'year' ? _react2.default.createElement(
                            'span',
                            null,
                            (0, _experiumPlayerHelpers.getEncodedYearData)((0, _path3.default)(['value', 'value'], input)) || ''
                        ) : null,
                        (0, _path3.default)(['input', 'type'], option) === 'month_year' ? _react2.default.createElement(
                            'span',
                            null,
                            (0, _experiumPlayerHelpers.getEncodedMonthData)((0, _path3.default)(['value', 'value'], input))
                        ) : null
                    );
                }
            }) : option.type === 'table' ? _react2.default.createElement(
                'div',
                { key: name + '[' + index + '].' + itemIndex },
                option.items.map(function (subOption, subIndex) {
                    return subOption.id ? _react2.default.createElement(_reactFinalForm.Field, {
                        key: name + '[' + index + '].' + subOption.id,
                        name: name + '[' + index + '].' + subOption.id,
                        render: function render(_ref3) {
                            var input = _ref3.input;
                            return _react2.default.createElement(
                                'span',
                                { className: 'subTitles', key: subOption.id },
                                (0, _path3.default)(['select', 'selection'], subOption) === 'dropdown' ? _react2.default.createElement(
                                    _experiumPlayerHelpers.DictionariesContext.Consumer,
                                    null,
                                    function (dictionaries) {
                                        var dictionary = (0, _find3.default)(function (dict) {
                                            return dict.id === subOption.select.scaleid;
                                        }, dictionaries);
                                        var value = (0, _path3.default)(['value'], input);
                                        var dictValue = (0, _find3.default)(function (dictOption) {
                                            return dictOption.id === (0, _path3.default)(['value'], value);
                                        }, (0, _path3.default)(['eval'], dictionary) || []);

                                        return _react2.default.createElement(
                                            'h4',
                                            null,
                                            '\xA0',
                                            (dictValue ? (0, _experiumPlayerHelpers.getText)(dictValue) : (0, _path3.default)(['value'], value)) || ''
                                        );
                                    }
                                ) : (0, _is3.default)(String, (0, _path3.default)(['value', 'value'], input)) && (0, _path3.default)(['input', 'type'], subOption) === 'text' ? _react2.default.createElement(
                                    'h4',
                                    null,
                                    '\xA0',
                                    (0, _path3.default)(['value', 'value'], input)
                                ) : null,
                                subIndex && (0, _path3.default)(['value', 'value'], input) && separatorTypes[(0, _path3.default)(['input', 'type'], subOption)] ? ' - ' : ' ',
                                (0, _path3.default)(['input', 'type'], subOption) === 'date' ? _react2.default.createElement(
                                    'span',
                                    null,
                                    (0, _experiumPlayerHelpers.getEncodedDateData)((0, _path3.default)(['value', 'value'], input)) || ''
                                ) : null,
                                (0, _path3.default)(['input', 'type'], subOption) === 'year' ? _react2.default.createElement(
                                    'span',
                                    null,
                                    (0, _experiumPlayerHelpers.getEncodedYearData)((0, _path3.default)(['value', 'value'], input)) || ''
                                ) : null,
                                (0, _path3.default)(['input', 'type'], subOption) === 'month_year' ? _react2.default.createElement(
                                    'span',
                                    null,
                                    (0, _experiumPlayerHelpers.getEncodedMonthData)((0, _path3.default)(['value', 'value'], input))
                                ) : null
                            );
                        }
                    }) : null;
                })
            ) : null;
        })
    );
};

BlockTitles.propTypes = {
    item: _propTypes2.default.object,
    name: _propTypes2.default.string,
    index: _propTypes2.default.number
};

exports.default = BlockTitles;